import { render, staticRenderFns } from "./DriverDetailProfile.vue?vue&type=template&id=1c42d64a&scoped=true&"
import script from "./DriverDetailProfile.vue?vue&type=script&lang=js&"
export * from "./DriverDetailProfile.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetailProfile.vue?vue&type=style&index=0&id=1c42d64a&scoped=true&lang=css&"
import style1 from "./DriverDetailProfile.vue?vue&type=style&index=1&id=1c42d64a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42d64a",
  null
  
)

export default component.exports